"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_loading_1 = __importDefault(require("@doordash/component-loading"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var LayoutContext_1 = require("../../../Common/LayoutContext");
var enums_1 = require("../../../Common/utils/enums");
var useTracking_1 = __importDefault(require("../../../Common/utils/useTracking"));
var CardBillingAddress_1 = __importDefault(require("../../CardFields/CardBillingAddress"));
var CardFieldsStyles_1 = require("../../CardFields/CardFieldsStyles");
var StripeInput_1 = __importDefault(require("../../CardFields/StripeInput"));
var Providers_1 = require("../../Providers");
var types_1 = require("../../types");
var useVgsForm_1 = __importDefault(require("../../utils/useVgsForm"));
var VerifyCardError_1 = __importDefault(require("../../VerifyCardError"));
var VerifyPaymentCardContext_1 = __importDefault(require("../../VerifyPaymentCardContext"));
var VerifyPaymentCardStrings_1 = __importDefault(require("../../VerifyPaymentCardStrings"));
var FORM_IDS = {
    cardCVC: 'cc-cvc',
    cardExpiration: 'cc-expiration',
    cardNumber: 'cc-number'
};
var VgsSecondCard = function (_a) {
    var isVgsLoaded = _a.isVgsLoaded, onClose = _a.onClose, vgsErrorMessage = _a.vgsErrorMessage;
    var _b = React.useContext(LayoutContext_1.LayoutContext), primaryAction = _b.primaryAction, setPrimaryAction = _b.setPrimaryAction;
    var paymentCard = React.useContext(VerifyPaymentCardContext_1["default"]).paymentCard;
    var secondCardVerify = Providers_1.useSecondCardVerifyMutation().secondCardVerify;
    var onSubmit = React.useCallback(function (tokenizedData) {
        return secondCardVerify({
            cardData: tokenizedData,
            cardId: paymentCard.id,
            tokenizationProvider: enums_1.TokenizationProvider.VGS
        });
    }, [secondCardVerify]);
    var formSubmit = useVgsForm_1["default"](isVgsLoaded, onSubmit, FORM_IDS).formSubmit;
    var _c = __read(React.useState({}), 2), billingAddress = _c[0], setBillingAddress = _c[1];
    var _d = __read(React.useState({ inlineErrors: {}, globalError: undefined }), 2), formSubmitErrors = _d[0], setFormSubmitErrors = _d[1];
    var _e = useTracking_1["default"](), trackClick = _e.trackClick, trackFailure = _e.trackFailure, trackSuccess = _e.trackSuccess;
    var handleSubmit = function () {
        // Reset loading and errors.
        setPrimaryAction({ isSubmitting: true });
        setFormSubmitErrors({ inlineErrors: {}, globalError: undefined });
        trackClick();
        formSubmit(handleSubmitSuccess, handleSubmitFailure, billingAddress);
    };
    var handleSubmitSuccess = React.useCallback(function () {
        setPrimaryAction({ isSubmitting: false });
        trackSuccess();
        if (onClose) {
            onClose();
        }
    }, [trackSuccess]);
    var handleSubmitFailure = React.useCallback(function (errors) {
        setFormSubmitErrors(errors);
        setPrimaryAction({ isSubmitting: false });
        if (errors.globalError) {
            var reason = errors.globalError.reason;
            var message = errors.globalError.message;
            trackFailure({ reason: reason, message: message });
        }
        else {
            var message = JSON.stringify(errors.inlineErrors);
            trackFailure({ message: message, reason: 'vgs_validation_failure' });
        }
    }, [trackFailure]);
    var clearSelectedBillingAddress = function () {
        setBillingAddress({
            addressLine1: undefined,
            zip: undefined
        });
    };
    var onSelectBillingAddress = function (address) {
        if (address) {
            setBillingAddress({
                addressLine1: address.printableAddress,
                zip: address.zipCode
            });
        }
        else {
            clearSelectedBillingAddress();
        }
    };
    React.useEffect(function () {
        if (primaryAction && primaryAction.isSubmitting) {
            handleSubmit();
        }
    }, [primaryAction && primaryAction.isSubmitting]);
    if (vgsErrorMessage) {
        return (React.createElement(design_language_1.Text, { color: design_language_1.Text.Colors.TextError, styles: design_language_1.Text.Styles.Bold16 }, vgsErrorMessage));
    }
    if (!isVgsLoaded) {
        return React.createElement(component_loading_1["default"], null);
    }
    return (React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.XLarge },
        React.createElement(CardFieldsStyles_1.FormContainer, null,
            React.createElement(design_language_1.InlineChildren, null,
                React.createElement(CardFieldsStyles_1.FormRow, null,
                    React.createElement(CardFieldsStyles_1.NumberStyling, null,
                        React.createElement(StripeInput_1["default"], { labelName: VerifyPaymentCardStrings_1["default"].cardDetails(), error: formSubmitErrors.inlineErrors[types_1.VgsFormFieldName.Number] || '' },
                            React.createElement(CardFieldsStyles_1.VgsInputContainer, { id: FORM_IDS.cardNumber }))),
                    React.createElement(CardFieldsStyles_1.CVVStyling, null,
                        React.createElement(StripeInput_1["default"], { labelName: "CVV", error: formSubmitErrors.inlineErrors[types_1.VgsFormFieldName.CVC] || '' },
                            React.createElement(CardFieldsStyles_1.VgsInputContainer, { id: FORM_IDS.cardCVC }))))),
            React.createElement(CardFieldsStyles_1.FormRow, null,
                React.createElement(CardFieldsStyles_1.InputWidth, null,
                    React.createElement(StripeInput_1["default"], { labelName: VerifyPaymentCardStrings_1["default"].cardExpiration(), error: formSubmitErrors.inlineErrors[types_1.VgsFormFieldName.Expiration] || '' },
                        React.createElement(CardFieldsStyles_1.VgsInputContainer, { id: FORM_IDS.cardExpiration })))),
            React.createElement(CardFieldsStyles_1.FormRow, null,
                React.createElement(CardFieldsStyles_1.BillingAddressStyling, null,
                    React.createElement(CardBillingAddress_1["default"], { clearSelected: clearSelectedBillingAddress, error: formSubmitErrors.inlineErrors[types_1.VgsFormFieldName.BillingAddress] || '', onSelect: onSelectBillingAddress }))),
            !(primaryAction && primaryAction.isSubmitting) &&
                formSubmitErrors.globalError && (React.createElement(CardFieldsStyles_1.AddCardError, null,
                React.createElement(design_language_1.Text, null, formSubmitErrors.globalError.displayMsg || (React.createElement(VerifyCardError_1["default"]
                // tslint:disable-next-line:max-line-length
                , { 
                    // tslint:disable-next-line:max-line-length
                    defaultError: VerifyPaymentCardStrings_1["default"].unableToVerifyPleaseTryAgain() }))))))));
};
exports["default"] = VgsSecondCard;
